module.exports = __webpack_public_path__ + "img/75775.2532737b.svg";